import { render, staticRenderFns } from "./regulamento.vue?vue&type=template&id=390777d3&scoped=true"
import script from "./regulamento.vue?vue&type=script&lang=js"
export * from "./regulamento.vue?vue&type=script&lang=js"
import style0 from "./regulamento.vue?vue&type=style&index=0&id=390777d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390777d3",
  null
  
)

export default component.exports